import type { OpenAPI } from "simplydo/interfaces";

import constants from "utils/constants";

import RoleEditor from "../../Roles/RoleEditor";

type RolesProps = {
  businessProfile: OpenAPI.Schemas["IdeaBusinessProfile"];
  closeModal: () => void;
};

export const Roles = ({ businessProfile }: RolesProps) => {
  return (
    <RoleEditor
      forType="ideaBusinessProfile"
      forId={businessProfile._id}
      permissionGroups={[
        {
          id: businessProfile._id,
          type: "ideaBusinessProfiles",
          title: "Business Profile",
          permissions: constants.permissions.ideaBusinessProfile,
        },
      ]}
      canCreateNewRoles
      canSetRolesAsDefault
    />
  );
};
